module.exports = __webpack_public_path__ + "images/2-i_loce6bb4eebbf9225124bd2bb46b7afbb14.svg";